/**
 * @author: subhasish.ghosh@zoom.us
 */

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import React from "react";

const UserAvatar = ({ name }) =>
  name === "Guest" ? (
    <AccountCircleIcon sx={{ height: "48px", width: "45px" }} />
  ) : (
    <Stack direction="row" spacing={2}>
      <Avatar {...stringAvatar(name)} />
    </Stack>
  );

const stringAvatar = (name) => {
  if (!name) {
    return {
      sx: {
        bgcolor: stringToColor("default"),
      },
      children: "?",
    };
  }

  const parts = name.split(" ");
  const firstName = parts[0] || "";
  const lastName = parts[parts.length - 1] || "";

  const initials = `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase();

  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: initials || "?",
  };
};

const stringToColor = (name) => {
  let hash = 0;

  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
};

export default UserAvatar;
